import PageHeading from "@/components/headings/PageHeading";
import { DetailHero, DetailHero2 } from "@/assets/images/svg/Icons";
import "./Hero.scss";

const Hero = () => {
  return (
    <section className="hero-subpage">
      <div className="container">
        <div className="position-relative hero-subpage__wrapper">
          <div className="pulse">
            <DetailHero />
          </div>
          <div className="pulse">
            <DetailHero2 />
          </div>
          <div className="hero-subpage__content">
            <span className="d-block font-italic text-center">
              TRENING UMYSŁU Z
            </span>
            <PageHeading variant="h1">
              <span>H&B</span> BLOG
            </PageHeading>
            <p className="text-center">
              Przygotowałem dla Was zestaw artykułów, które pomogą Wam w
              sportowej edukacji. Wiedza to podstawa efektywnego treningu,
              dlatego zachęcamy do lektury!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
